import { defineMessages } from 'react-intl';

export default defineMessages({
  amount: {
    id: 'sentinel.components.updateAmountForm.amount',
    defaultMessage: 'Amount',
  },
  comment: {
    id: 'sentinel.components.updateAmountForm.comment',
    defaultMessage: 'Comment',
  },
  editAmount: {
    id: 'sentinel.components.updateAmountForm.editAmount',
    defaultMessage: 'Edit Amount',
  },
});



// WEBPACK FOOTER //
// ./src/components/UpdateAmountForm/messages.js